/** Local-first storage: projects live in the browser's IndexedDB until accounts arrive (plan Phase 5). */
import Dexie, { type Table } from 'dexie';
import type { ProjectDoc } from '../model/types';

export interface StoredProject {
  id: string;
  name: string;
  updatedAt: number;
  doc: ProjectDoc;
}

class ExtentDb extends Dexie {
  projects!: Table<StoredProject, string>;
  constructor() {
    super('extent');
    this.version(1).stores({ projects: 'id, updatedAt' });
  }
}

export const db = new ExtentDb();

export const newId = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `id-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
